<template lang="pug">
el-card
    common-form(
        ref="form"
        v-bind="form.attrs"
        :options="form.formInfo"
        :values="value"
    )
    span.footer
      el-button(type="primary" @click="Submit") 提 交
      el-button(@click="$router.go(-1)") 取 消
</template>

<script>
export default {
    name: 'my',
    data () {
        return {
            form: {
                attrs: {
                    labelWidth: '130px',
                    labelPosition: 'left',
                },
                formInfo: [
                    {
                        name: '原始密码',
                        component: 'el-input',
                        key: 'password',
                        attrs: {
                            type: 'password',
                            placeholder: '请输入原始密码',
                        },
                        rules: [
                            { required: true, message: '请输入原始密码', trigger: 'blur' }
                        ]
                    },
                    {
                        name: '新密码',
                        component: 'el-input',
                        key: 'newpassword',
                        attrs: {
                            type: 'password',
                            placeholder: '请输入新密码',
                        },
                        rules: [
                            // { required: true, message: '请输入新密码', trigger: 'blur' }
                        ]
                    },
                    {
                        name: '再次输入新密码',
                        component: 'el-input',
                        key: 'renewpassword',
                        attrs: {
                            type: 'password',
                            placeholder: '请再次输入新密码',
                        },
                        rules: [
                            // { required: true, message: '请再次输入新密码', trigger: 'blur' }
                        ]
                    },
                ]
            },
            value: {}
        }
    },
    methods: {
        async Submit() {
            let {form, hasError} = this.$refs.form.getFormData()
            if (hasError) return
            if (form.renewpassword != form.newpassword) {
                this.$store.commit('alert', {
                    type: 'error',
                    message: '两次密码输入不一致'
                })
                return
            }
            try {
                await this.$api.ResetPassword(form)
                this.$router.go(-1)
            } catch(e) {
                console.log(e)
                return 
            }
        }
    }
}
</script>